export default __webpack_public_path__ + "static/media/gflix-logo.bd5480c6.png";